import { render, staticRenderFns } from "./EnvironmentAttributes.vue?vue&type=template&id=4d486792&"
import script from "./EnvironmentAttributes.vue?vue&type=script&lang=js&"
export * from "./EnvironmentAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports